import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {LocaleLink} from '@/routes';
import {userCtx} from '@/auth';
import styles from '@/views/Layout/b2c/Member.module.css';

const Member = () => {
  const user = useContext(userCtx);
  const {t: tr, i18n: i18nCtx} = useTranslation();
  const {t: trPlanDetail} = useTranslation('planDetail');

  return (
    <div className={`menu member ${styles.member}`}>
      <LocaleLink to='/b2c'>
        <i className='notification'>{`${user.currentClient.messageCount}`}</i>{' '}
        {`${user.currentClient.name} `}
        <i className='material-icons'>keyboard_arrow_down</i>
      </LocaleLink>
      <ul className={`member_nav ${styles.member_nav}`}>
        {i18nCtx.language === 'ja' && (
          <li className={`${styles.member_nav_remark}`}>
            {trPlanDetail('auto_translate_remark_1')}
            {trPlanDetail('auto_translate_remark_2')}
          </li>
        )}
        <li>
          <LocaleLink to='/b2c'>{tr('my_plan')}</LocaleLink>
        </li>
        <li>
          <LocaleLink to='/b2c/my_profile'>{tr('my_profile')}</LocaleLink>
        </li>
        <li>
          <LocaleLink to='/b2c/message'>
            <i className='notification'>
              {`${user.currentClient.messageCount}`}
            </i>{' '}
            {tr('message_box')}
          </LocaleLink>
        </li>
        <li>
          <LocaleLink to='/b2c/change_password'>
            {tr('change_password_button')}
          </LocaleLink>
        </li>
      </ul>
    </div>
  );
};

export default Member;
